import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingBackgroundColorChangerConfig } from '@/data/landingConfig/landingBackgroundColorChangerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_BackgroundColorChanger } from './schemaObject';

interface Props {}
const BackgroundColorChanger: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_BackgroundColorChanger} />
			<LandingTemplate
				data={landingBackgroundColorChangerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelRemoveBGV3()}
			/>
		</>
	);
};

export default BackgroundColorChanger;
